<template>
	<v-row class="ma-0 pb-offset">
        <v-col cols="12" class="pa-0">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Altre Impostazioni</p>
                    <v-spacer></v-spacer>
                </v-card-title>                
                <v-divider></v-divider>
                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Prodotti Preventivo</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['recalculate_price_at_changed_quantity']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Ricalcolo Prezzo alla modifica della quantità</v-list-item-title>
                            <v-list-item-subtitle>Fai si che al modificare della quantità il prezzo del prodotto venga ricalcolato utilizzando un listino di tipo scaglione quantità
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Conversione in Ordine</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['quotation_order_select_option']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Genera ordine selezionando un'opzione (modifica il preventivo)</v-list-item-title>
                            <v-list-item-subtitle>Se attivo, alla generazione dell'ordine puoi scegliere quali blocchi/opzioni (delimitati dai subtotali) tenere: le opzioni non scelte vengono <strong>eliminate dal preventivo</strong> e poi si crea l'ordine, così ordine e preventivo coincidono. Disattivo: l'ordine copia l'intero preventivo (pulisci tu i blocchi nell'editor prima, se serve).
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['send_notifications_quotation_status']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Invia notifica al cambio di stato di un Preventivo</v-list-item-title>
                            <v-list-item-subtitle>Invia una notifica a un utente amministratore dei Preventivi al loro cambio di stato
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>                

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['send_notifications_quotation_status']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                                <v-slide-y-transition>
                                    <div>
                                        <v-row>
                                            <v-col class="px-2" cols="12" md="6" lg="5" >
                                                <v-select
                                                    name="Stati Preventivo"
                                                    label="Stati Preventivo"
                                                    :items="quotationStatus"
                                                    small-chips
                                                    dense
                                                    outlined
                                                    clearable
                                                    multiple
                                                    v-model="settings['send_notifications_quotation_status_selected']"
                                                    :error-messages="errors.collect('Stati Preventivo')"
                                                    v-validate="'required'"
                                                    :data-vv-name="'Stati Preventivo'"
                                                    :menu-props="{'offset-y': true}"
                                                ></v-select>
                                            </v-col>
                                            <v-col class="px-4" cols="12" md="6" lg="5" >
                                                <v-combobox
                                                    name="Indirizzo mail"
                                                    label="Indirizzo mail"
                                                    small-chips
                                                    combobox
                                                    dense
                                                    outlined
                                                    clearable
                                                    multiple
                                                    v-model="settings['send_notifications_quotation_status_email']"
                                                    :error-messages="errors.collect('Indirizzo mail')"
                                                    v-validate="'email'"
                                                    :data-vv-name="'Indirizzo mail'"
                                                ></v-combobox>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-slide-y-transition>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-subheader>Invio Email</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['send_mail_exclude_attachment']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Escludi allegato PDF di default</v-list-item-title>
                            <v-list-item-subtitle>Non includere automaticamente il PDF del preventivo come allegato nelle email</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>Mittente e destinatari predefiniti</v-list-item-title>
                            <v-list-item-subtitle>Imposta il mittente, i CC e i CCN che verranno precompilati nella schermata di invio email del preventivo. Restano comunque modificabili al momento dell'invio.</v-list-item-subtitle>
                            <v-row class="ma-0 mt-4">
                                <v-col cols="12" md="6" class="pa-1">
                                    <v-text-field
                                        label="Mittente (email)"
                                        v-model="settings['send_mail_default_from']"
                                        outlined
                                        dense
                                        clearable
                                        hint="Es: preventivi@azienda.it"
                                        persistent-hint
                                        :error-messages="errors.collect('Mittente')"
                                        v-validate="'email'"
                                        data-vv-name="Mittente"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="pa-1">
                                    <v-text-field
                                        label="Nome mittente"
                                        v-model="settings['send_mail_default_from_name']"
                                        outlined
                                        dense
                                        clearable
                                        hint="Es: Ufficio Preventivi"
                                        persistent-hint
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="pa-1">
                                    <v-combobox
                                        label="CC di default"
                                        small-chips
                                        combobox
                                        dense
                                        outlined
                                        clearable
                                        multiple
                                        hint="Premi invio per aggiungere un indirizzo"
                                        persistent-hint
                                        v-model="settings['send_mail_default_cc']"
                                        :error-messages="errors.collect('CC di default')"
                                        v-validate="'email'"
                                        data-vv-name="CC di default"
                                    ></v-combobox>
                                </v-col>
                                <v-col cols="12" md="6" class="pa-1">
                                    <v-combobox
                                        label="CCN di default"
                                        small-chips
                                        combobox
                                        dense
                                        outlined
                                        clearable
                                        multiple
                                        hint="Premi invio per aggiungere un indirizzo"
                                        persistent-hint
                                        v-model="settings['send_mail_default_ccn']"
                                        :error-messages="errors.collect('CCN di default')"
                                        v-validate="'email'"
                                        data-vv-name="CCN di default"
                                    ></v-combobox>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list three-line subheader class="background-2 pa-2" v-if="settings['quotations_signature']">
                    <v-subheader>Firma elettronica preventivo</v-subheader>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>Giorni di validità del link per la firma del preventivo</v-list-item-title>
                            <v-list-item-subtitle>Imposta i giorni/ore per cui il link del preventivo rimanga attivo. Quando nel preventivo è impostata la "Scadenza Preventivo" verrà impostata sul link tale scadenza, altrimenta sarà presa questa come scadenza.
                            </v-list-item-subtitle>
                            <v-row class="ma-0 mt-4">
                                <v-col class="col-6 ma-0 pa-0 pr-3">
                                    <v-select
                                        label="Giorni/Ore"
                                        :items="durations"
                                        v-model="settings['duration_type']"
                                        outlined
                                        dense
                                        :menu-props="{'offset-y': true}"
                                    ></v-select>
                                </v-col>
                                <v-col class="col-6 ma-0 pa-0 pl-3" v-if="settings['duration_type']">
                                    <v-text-field 
                                        label="Durata*"
                                        v-model="settings['duration']"
                                        type="number"
                                        outlined
                                        dense
                                        :error-messages="errors.collect('Durata')"
                                        v-validate="'required'"
                                        data-vv-name="Durata"
                                    ></v-text-field>   
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['merge_quotation_documents']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Unisci Documenti</v-list-item-title>
                            <v-list-item-subtitle>Unisci il file PDF del preventivo insieme ai PDF delle conizioni di servizio in un unico file da inviare via email al cliente
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['request_iban_on_signature']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Richiedi IBAN per pagamenti RID/RIBA</v-list-item-title>
                            <v-list-item-subtitle>Quando il preventivo ha una condizione di pagamento con metodo RID o RIBA, richiedi l'IBAN e il consenso SEPA durante la firma elettronica
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-slide-y-transition>
                        <div v-if="settings['request_iban_on_signature']">
                            <v-subheader class="mt-4">Impostazioni SEPA Direct Debit</v-subheader>

                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="mb-2">Dati Creditore (la vostra azienda)</v-list-item-title>
                                    <v-row class="ma-0">
                                        <v-col cols="12" md="6" class="pa-1">
                                            <v-text-field
                                                label="Ragione Sociale Creditore"
                                                v-model="settings['sepa_creditor_name']"
                                                outlined
                                                dense
                                                hint="Es: Azienda S.R.L."
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="pa-1">
                                            <v-text-field
                                                label="Indirizzo Creditore"
                                                v-model="settings['sepa_creditor_address']"
                                                outlined
                                                dense
                                                hint="Es: Via Roma 1, 00100 Roma"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="pa-1">
                                            <v-text-field
                                                label="Codice Identificativo Creditore (CID)"
                                                v-model="settings['sepa_creditor_id']"
                                                outlined
                                                dense
                                                hint="Es: IT00X 00000 00000 000000000000"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="pa-1">
                                            <v-select
                                                label="Tipologia SDD"
                                                :items="sddTypes"
                                                v-model="settings['sepa_sdd_type']"
                                                outlined
                                                dense
                                                hint="CORE per clienti privati e aziende, B2B solo tra aziende"
                                                :menu-props="{'offset-y': true}"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="mb-2">Codice Mandato</v-list-item-title>
                                    <v-row class="ma-0">
                                        <v-col cols="12" md="6" class="pa-1">
                                            <v-text-field
                                                label="Prefisso Codice Mandato"
                                                v-model="settings['sepa_mandate_prefix']"
                                                outlined
                                                dense
                                                hint="Il codice mandato sarà: PREFISSO + P.IVA cliente"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="mb-2">Spese e Condizioni</v-list-item-title>
                                    <v-row class="ma-0">
                                        <v-col cols="12" md="4" class="pa-1">
                                            <v-text-field
                                                label="Spese Incasso (€)"
                                                v-model="settings['sepa_collection_fee']"
                                                type="number"
                                                step="0.01"
                                                outlined
                                                dense
                                                hint="Es: 2.00"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="8" class="pa-1">
                                            <v-text-field
                                                label="Nota IVA"
                                                v-model="settings['sepa_vat_note']"
                                                outlined
                                                dense
                                                hint="Es: Tutti i costi sono espressi IVA ESCLUSA"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item>
                                <v-list-item-action>
                                    <v-checkbox color="primary" v-model="settings['sepa_request_legal_representative']"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>Richiedi dati Legale Rappresentante</v-list-item-title>
                                    <v-list-item-subtitle>Richiedi nome, cognome e codice fiscale del legale rappresentante (firmatario del conto corrente) durante la firma elettronica
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </div>
                    </v-slide-y-transition>

                </v-list>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="pa-2 mx-3" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>
        </v-col>

        <v-col cols="12" class="pa-0 pt-4">
            <numbering-check-settings
                model-name="quotation"
                document-label="i preventivi"
            />
        </v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue'
	import InputMixin from '@/mixins/InputMixin'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'
	import NumberingCheckSettings from '@/components/common/NumberingCheckSettings'

    export default {
        name: 'quotations-options',
		components: {
			NumberingCheckSettings
		},
		mixins: [SettingsOptionsMixin, InputMixin],
        props: {},
        data() {
            return {
                model: 'quotation',
                settings: {
                    'recalculate_price_at_changed_quantity': false,
                    'quotation_order_select_option': false,
                    'quotations_signature': false,
                    'request_iban_on_signature': false,
                    'duration_type': null,
                    'duration': '',
                    'merge_quotation_documents': false,
                    'send_notifications_quotation_status': false,
                    'send_notifications_quotation_status_selected': [],
                    'send_notifications_quotation_status_email': [],
                    'send_mail_exclude_attachment': false,
                    'send_mail_default_from': '',
                    'send_mail_default_from_name': '',
                    'send_mail_default_cc': [],
                    'send_mail_default_ccn': [],
                    'sepa_creditor_name': '',
                    'sepa_creditor_address': '',
                    'sepa_creditor_id': '',
                    'sepa_sdd_type': 'CORE',
                    'sepa_mandate_prefix': '',
                    'sepa_collection_fee': '',
                    'sepa_vat_note': '',
                    'sepa_request_legal_representative': false
                },
                quotationStatus: [],
                sddTypes: [
                    { text: 'CORE (Privati e Aziende)', value: 'CORE' },
                    { text: 'B2B (Solo Aziende)', value: 'B2B' }
                ],
                durations: [
                    {
                        text: 'Giorni',
                        value: 'days'
                    },
                    {
                        text: 'Ore',
                        value: 'hours',
                    }
                ]                
            }
        },

        watch: {
            settings: {
                handler() {
                    if(!this.settings['send_notifications_quotation_status']) {
                        Vue.set(this.settings, 'send_notifications_quotation_status_selected', null)
                        Vue.set(this.settings, 'send_notifications_quotation_status_email', null)
                    }
                },
                deep: true,
            }
        },

        created() {
            this.axios.get('settings/'+this.model).then(response => {

                _.forEach(response.data.settings, (setting) => {
                    Vue.set(this.settings, setting.key, setting.value)
                })

                this.axios.post('generaltype/', {key: 'quotation_status'}).then(response => {
                    this.quotationStatus = response.data.general_type

                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })



            }, response => {
                // error callback
            })
        }
    }
</script>